
import alt from '../alt';

/**
 * Teadete kuvamise tegevused.
 * Kasutamine:
 * 
 *  import NotificationActions from './actions/NotificationActions';
 *  NotificationActions.error(message);
 *  
 */
class NotificationActions {
	constructor() {
		this.generateActions(
			'info',
			'warning',
			'success',
			'error',
			'dismiss',
			'clear'
		);
	}
}

export default alt.createActions(NotificationActions);
